export default __webpack_public_path__ + "static/Haier Outdoor-c1ae75453f8542168faab21e8027a4ab.jpg";